<res-base-modal modalTitle="Update Metadata" modalClass="update-metadata-modal" [modalAutomationId]="modalAutomationId"
    modalContainerAutomationId="update-metadata" primaryButtonLabel="OK" (primaryButtonActionEmt)="ok()"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" (closeButtonActionEmt)="closeModal()" secondaryButtonLabel="Cancel"
    [modalHelpIndex]="modalHelpIndex" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">
    <div class="content-div">
        <label for="cmbMetadata">Metadata Field:</label>
        <select id="cmbMetadata" [(ngModel)]="selectedMetadata"
            [attr.data-automation-id]="modalAutomationId + '-metadata-field-option'">
            <option *ngFor="let metadata of metadataFields | values" [value]="metadata">{{metadata}}</option>
        </select>
        <div></div>
        <label for="txtNewValue">New Value:</label>
        <input id="txtNewValue" [(ngModel)]="metadataValue" maxlength="100" (ngModelChange)="validateNameCharacters()"
            [disabled]="isRemoveValue" [attr.data-automation-id]="modalAutomationId + '-new-value-input'"
            (focusout)="validateOnBlur(selectedMetadata)" class="error-popover" containerClass="error" container="body"
            [popover]="errorPopoverTemplate" triggers="" #errorPopover="bs-popover" placement="right">
        <res-custom-checkbox [attr.data-automation-id]="modalAutomationId + '-remove-value'" [(ngModel)]="isRemoveValue"
            (ngModelChange)="onIsRemoveValue()" content="Remove Value">
        </res-custom-checkbox>
        <ng-template #errorPopoverTemplate>
            <span data-automation-id="update-metadata-modal-metadata-value-error">{{errorMessage}}</span>
            <i class="fa fa-close" (click)="errorPopover.hide()"></i>
        </ng-template>
    </div>
</res-base-modal>